var React = require('react');

function Up (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 35C27.3854 35 35 27.3854 35 18C35 8.61458 27.3854 1 18 0.999999C8.61458 0.999999 1 8.61458 1 18C1 27.3854 8.61458 35 18 35Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M10.9168 17.4134L18.0002 10.3849L25.0835 17.4134","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18 11.3622L18 25.6148","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Up.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Up;

Up.default = Up;
